import Auth from "@aws-amplify/auth";
import React, { useEffect } from "react";

const LogoutFederate = (props) => {
  const didMount = async () => {
    try {
      console.log("🚀 ~ file: LoginFederate.jsx ~ line 9 ~ didMount");
      let currentUser = await Auth.currentAuthenticatedUser();
      console.log(
        "🚀 ~ file: LogoutFederate.jsx ~ line 9 ~ didMount ~ currentUser",
        currentUser
      );
      if (currentUser) {
        await Auth.signOut();
        alert("HAY USUARIO");
      } else alert("NO HAY USUARIO");
    } catch (error) {
      console.log(
        "🚀 ~ file: LogoutFederate.jsx ~ line 14 ~ didMount ~ error",
        error
      );
      alert("ERROR ");
    }
  };

  useEffect(() => {
    didMount();
  }, []);

  return <></>;
};

export default LogoutFederate;